/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { useApi } from '../services';

export const useGetPlanCoveragePersonByIdPerson = (idPerson) => useApi(`/v2/plan-coverage-person/person/${idPerson}`, 'GET', {}, {}, true);
